import type { Validation } from "@/lib/validation"

export const buildValidationResult = <Subject>({
  failures,
  salvage,
  subject,
}: {
  failures: Validation.Failure[]
  salvage?: Subject
  subject: Subject | unknown
}): Validation.Result<Subject> => {
  return {
    failures,
    salvage,
    subject: subject as Subject,
    valid: failures.length === 0,
  }
}
